import { Select, SelectChangeEvent, SelectProps, useTheme } from '@mui/material';
import React from 'react';

interface ISelectDefaultProps extends Omit<SelectProps<string>, 'value' | 'onChange'> {
  value: string;
  onChange?: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
  children: React.ReactNode;
  mobileFullWidth?: boolean;
  minWidth?: number | string;
}

export const SelectDefault: React.FC<ISelectDefaultProps> = ({ value, onChange, children, sx, mobileFullWidth = false, minWidth, ...props }) => {
  const theme = useTheme();

  return (
    <Select<string>
      {...props}
      value={value}
      onChange={onChange}
      sx={{
        ...(mobileFullWidth && { width: { xs: '100%', sm: 'auto' } }),
        ...(minWidth && { minWidth }),
        height: '43px',
        ...(mobileFullWidth && {
          '& .MuiSelect-select': {
            textAlign: { xs: 'center', sm: 'left' },
          },
        }),
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          '&.Mui-focused fieldset': {
            border: `1px solid ${theme.palette.secondary.main}`,
          },
        },
        '& .MuiFormControl-root.MuiTextField-root': {
          '&:hover': {
            borderColor: theme.palette.secondary.main,
          },
        },
        '& fieldset': {
          top: '0',
          '& legend': {
            display: 'none',
          },
        },
        '& .MuiInputBase-input': {
          padding: '10px 16px',
          color: theme.palette.text.primary,
        },
        ...sx,
      }}
    >
      {children}
    </Select>
  );
};
